import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const AvatarStyle = styled(Box)(({ backgroundColor }) => ({
  borderRadius: '3px',
  height: '16px',
  width: '22px',
  background: backgroundColor
}))
